<template>
  <div>
    <v-dialog
      v-model="dialog"
      persistent
      scrollable
      class="dialog-container"
      :max-width="dialogMaxWidth"
      eager
      :id="`${dialogId}-container`"
    >
      <v-form ref="formRefProxy" @submit.prevent="saveAndLoad">
        <v-card>
          <v-card-title class="primary-background dialog-title">
            <slot name="dialog.title"></slot>
            <v-spacer></v-spacer>
            <v-btn icon @click="closeDialog">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text class="dialog-content pb-0" :id="dialogId">
            <slot name="dialog.content"></slot>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions v-if="!hideActionBar">
            <slot name="dialog.actions.extra"></slot>
            <v-spacer></v-spacer>
            <v-btn text @click.stop="dialog = false">
              <slot name="dialog.actions.close">Fermer</slot>
            </v-btn>
            <v-btn
              color="primary"
              type="submit"
              :loading="loadingProxy"
              :disabled="disableAction"
            >
              <slot name="dialog.actions.save">Enregistrer</slot>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
  </div>
</template>
<script>
import {
  defineComponent,
  computed,
  onMounted,
  onUnmounted,
} from "@vue/composition-api";

export default defineComponent({
  props: {
    dialogId: {
      type: String,
      required: true,
    },
    maxWidth: [Number, String],
    formRef: Object,
    open: Boolean,
    loading: Boolean,
    disableAction: {
      type: Boolean,
      default: false,
    },
    hideActionBar: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    /* Cycle de vie */
    onMounted(() => {
      makeDialogScrollable();
      window.addEventListener("resize", makeDialogScrollable);
      emit("base-dialog-mounted");
    });
    onUnmounted(() => {
      window.removeEventListener("resize", makeDialogScrollable);
      emit("base-dialog-destroyed");
    });

    /* Variables */

    /* Computed */
    const dialog = computed({
      get: function () {
        return props.open;
      },
      set: function (value) {
        emit("update:open", value);
      },
    });
    const dialogMaxWidth = computed(function () {
      return props.maxWidth ?? "500px";
    });
    const formRefProxy = computed({
      get: function () {
        return props.formRef;
      },
      set: function (value) {
        emit("update:formRef", value);
      },
    });
    const loadingProxy = computed({
      get: function () {
        return props.loading;
      },
      set: function (value) {
        emit("update:loading", value);
      },
    });

    /* Méthodes */
    const makeDialogScrollable = function () {
      // On récupère la modale
      const modalContainer = document.getElementById(
        `${props.dialogId}-container`
      );
      if (modalContainer) {
        // ...et pareil pour celui du contenu
        const contentContainer = document.querySelector(`#${props.dialogId}`);
        //const contentRect = contentContainer.getBoundingClientRect();
        //const contentContainerHeight = contentRect.bottom - contentRect.top;
        // On détermine si la modale est en overflow
        const modalOverflowing =
          contentContainer.scrollHeight > contentContainer.clientHeight;

        // Si la modale est en overflow, on fixe la hauteur de content-container à celle qu'il a actuellement
        if (modalOverflowing) {
          contentContainer.style.height = `${contentContainer.clientHeight}px`;
        } else {
          contentContainer.style.height = "auto";
        }
      }
    };
    const saveAndLoad = function () {
      loadingProxy.value = true;
      emit("save-item");
    };
    const closeDialog = function () {
      emit("update:open", false);
    };

    /* Watchers */

    return {
      formRefProxy,
      dialog,
      saveAndLoad,
      dialogMaxWidth,
      loadingProxy,
      closeDialog,
    };
  },
});
</script>
